module.exports = __webpack_public_path__ + "../resources/img/storebadge_pt.8fd45f10.svg";